export default __webpack_public_path__ + "e0722cad9f8650f9fd8b3cdc516dc946.png";